import React from 'react';
import { Box, Flex, Input, Text } from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';
import { CampaignMapping } from 'src/api/campaignMappings';

type Props = {
  row: CampaignMapping;
  rowIndex: number;
  cardBg: string;
  isEditing: boolean;
  editValue: string;
  setEditValue: (v: string) => void;
  onEditCommit: (rowIndex: number) => void;
  onKeyPress: (e: React.KeyboardEvent, rowIndex: number) => void;
  onStartEdit: (rowIndex: number, currentValue: string) => void;
};

export const CampaignNameCell: React.FC<Props> = ({
  row,
  rowIndex,
  cardBg,
  isEditing,
  editValue,
  setEditValue,
  onEditCommit,
  onKeyPress,
  onStartEdit,
}) => {
  return (
    <Box paddingY={2} px={2} bg={cardBg} h="100%">
      {isEditing ? (
        <Input
          value={editValue}
          onChange={(e) => setEditValue(e.target.value)}
          onBlur={() => onEditCommit(rowIndex)}
          onKeyDown={(e) => onKeyPress(e, rowIndex)}
          autoFocus
          size="sm"
          variant="filled"
          bg="surface.card"
          border="1px solid"
          borderColor="blue.300"
          _focus={{
            borderColor: 'blue.500',
            boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)',
          }}
        />
      ) : (
        <Flex align="center" gap={2} justify="space-between">
          <Text
            color="text.title"
            cursor="pointer"
            fontWeight="semibold"
            _hover={{ color: 'blue.600' }}
            onClick={() => onStartEdit(rowIndex, row.campaign_name)}
            title="Click to edit campaign name">
            {row.campaign_name}
          </Text>
          <Icon
            iconName="gear"
            w={3}
            h={3}
            onClick={() => onStartEdit(rowIndex, row.campaign_name)}
            cursor="pointer"
            mr={2}
          />
        </Flex>
      )}
      {row.campaign_name !== row.original_campaign_name && (
        <Text fontSize="sm" color="text.darkGray">
          Original: {row.original_campaign_name}
        </Text>
      )}
    </Box>
  );
};
